import { create } from 'zustand';

interface DialogState {
  isOpen: boolean;
  disableFooter: boolean;
  content: React.ReactNode;
  closeButtonLabel: string;
  saveButtonLabel: string;
  onSave: () => void;
  mousePositionWithScroll: number;
  openDialog: (
    content: React.ReactNode,
    onSave: () => void,
    disableFooter?: boolean,
  ) => void;
  closeDialog: () => void;
  setCloseButtonLabel: (label: string) => void;
  setSaveButtonLabel: (label: string) => void;
  setMousePositionWithScroll: (position: number) => void;
}

export const useDialogStore = create<DialogState>((set) => ({
  isOpen: false,
  disableFooter: false,
  content: null,
  closeButtonLabel: 'Abbruch',
  saveButtonLabel: 'Weiter',
  onSave: () => {},
  mousePositionWithScroll: 0,
  setMousePositionWithScroll: (position: number) =>
    set({ mousePositionWithScroll: Math.floor(position) }),
  openDialog: (content, onSave, disableFooter = false) =>
    set({ isOpen: true, content, onSave, disableFooter }),
  closeDialog: () => set({ isOpen: false, content: null, onSave: () => {} }),
  setCloseButtonLabel: (label) => set({ closeButtonLabel: label }),
  setSaveButtonLabel: (label) => set({ saveButtonLabel: label }),
}));
